import axios from 'axios';
import { datadogLogs } from '@datadog/browser-logs';
import { ENV_CONFIG } from 'config/environment';
import { coerceClientId, withCoercedClientId, withCoercedPages } from 'helpers/utils';

const countInvalidClientIds = (data: unknown): number => {
  if (Array.isArray(data)) {
    return data.reduce((total: number, item) => total + countInvalidClientIds(item), 0);
  }
  if (data == null || typeof data !== 'object') return 0;
  const { client_id, pages } = data as { client_id?: unknown; pages?: unknown };
  const self =
    client_id != null && coerceClientId(client_id as string | number) === undefined ? 1 : 0;
  return self + countInvalidClientIds(pages);
};

const coercePayload = <T>(data: T): T => {
  if (Array.isArray(data)) return data.map(item => coercePayload(item)) as T;
  if (data == null || typeof data !== 'object') return data;
  const withClientId = withCoercedClientId(data as { client_id?: number | null });
  return withCoercedPages(withClientId as { pages?: Array<{ client_id?: number | null }> }) as T;
};

export const coerceApiClientIds = <T>(data: T): T => {
  const invalidCount = countInvalidClientIds(data);
  if (invalidCount > 0) {
    datadogLogs.logger.warn('Discarded non-integer client_id(s) from API response', {
      count: invalidCount,
    });
  }
  return coercePayload(data);
};

export const oathApi = axios.create({
  baseURL: ENV_CONFIG().API.BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': process.env.REACT_APP_API_KEY,
  },
});

oathApi.interceptors.response.use(response => {
  response.data = coerceApiClientIds(response.data);
  return response;
});
